/**
 * enum GameStatus - possible game statuses.
 */
export enum GameStatus {
    /**
     * @member active - game is active
     */
    Active = <any>'active',

    /**
     * @member closed - game is closed.
     */
    Closed = <any>'closed'
}


/** WEBPACK FOOTER **
 ** ./Engine/Communication/Game/Types/GameStatus.ts
 **/